export const DISCOVERED_TRANSLATION_KEYS = {
  PURCHASE_SUCCESSFUL: {
    key: "purchaseSuccessfulKey",
    value: "Purchase successful",
  },
  PLEASE_SHARE_A_SUPPORTED_FILE_TYPE: {
    key: "pleaseShareASupportedFileTypeKey",
    value: "Please share a supported file type",
  },
  UNEXPECTED_ERROR: {
    key: "unexpectedErrorKey",
    value: "Unexpected error",
  },
  ERROR: {
    key: "errorKey",
    value: "Error",
  },
  PAGES: {
    key: "pagesKey",
    value: "Pages",
  },
  TESTIMONIAL_RESEARCH_PAPERS: {
    key: "testimonialResearchPapersKey",
    value:
      "I listen to research papers during my commute and get through twice as much material. Frateca completely changed how I learn.",
  },
  GRADUATE_STUDENT: {
    key: "graduateStudentKey",
    value: "Graduate Student",
  },
  LISTEN_TO_DOCUMENTS_SUBTITLE: {
    key: "listenToDocumentsSubtitleKey",
    value: "Listen to your PDFs, Word files, books and more",
  },
  WEB_ARTICLES_SUBTITLE: {
    key: "webArticlesSubtitleKey",
    value: "Turn any web page or article link into audio",
  },
  PASTED_TEXT_SUBTITLE: {
    key: "pastedTextSubtitleKey",
    value: "Type or paste any text to hear it read aloud",
  },
  IMAGES_SUBTITLE: {
    key: "imagesSubtitleKey",
    value: "Use your camera to capture and listen to printed text",
  },
  VOICE_SELECTED_SUCCESSFULLY: {
    key: "voiceSelectedSuccessfullyKey",
    value: "Voice selected successfully!",
  },
  FAILED_TO_OPEN_BILLING_PORTAL: {
    key: "failedToOpenBillingPortalKey",
    value: "Failed to open billing portal",
  },
  FILE_TYPE_NOT_SUPPORTED: {
    key: "fileTypeNotSupportedKey",
    value: "File type not supported",
  },
  INVALID_FILE_TYPE: {
    key: "invalidFileTypeKey",
    value: "Invalid file type",
  },
  PASSWORD_CHANGED_SUCCESSFULLY: {
    key: "passwordChangedSuccessfullyKey",
    value: "Password changed successfully",
  },
  NO_CONTENT_YET: {
    key: "noContentYetKey",
    value: "No content yet",
  },
  UPLOAD_ADOCUMENT_PASTE_TEXT_OR_ADD_AWEB_ARTICLE_TO_GET_STARTED_WITH_AUDIO_CONVERSION:
    {
      key: "uploadADocumentPasteTextOrAddAWebArticleToGetStartedWithAudioConversionKey",
      value:
        "Upload a document, paste text, or add a web article to get started with audio conversion.",
    },
  OF: {
    key: "ofKey",
    value: "of",
  },
  STARTED_AT: {
    key: "startedAtKey",
    value: "Started at:",
  },
  PLEASE_UPDATE_THE_APP: {
    key: "pleaseUpdateTheAppKey",
    value: "Please update the app",
  },
  TO_CONTINUE_ENJOYING_ALL_THE_FEATURES_AND_IMPROVEMENTS_OF_FRATECA_APP_AN_UPDATE_IS_REQUIRED_UPDATE_ENSURES_YOU_HAVE_THE_BEST_PERFORMANCE_AND_ASEAMLESS_EXPERIENCE:
    {
      key: "toContinueEnjoyingAllTheFeaturesAndImprovementsOfFratecaAppAnUpdateIsRequiredUpdateEnsuresYouHaveTheBestPerformanceAndASeamlessExperienceKey",
      value:
        "To continue enjoying all the features and improvements of Frateca app, an update is required. Update ensures you have the best performance and a seamless experience.",
    },
  UPDATE_NOW: {
    key: "updateNowKey",
    value: "Update now",
  },
  APP_UNDER_MAINTENANCE: {
    key: "appUnderMaintenanceKey",
    value: "🛠 App Under Maintenance",
  },
  WE_RE_CURRENTLY_PERFORMING_SOME_UPDATES_TO_IMPROVE_YOUR_EXPERIENCE_PLEASE_CHECK_BACK_LATER_THANKS_FOR_YOUR_PATIENCE:
    {
      key: "weReCurrentlyPerformingSomeUpdatesToImproveYourExperiencePleaseCheckBackLaterThanksForYourPatienceKey",
      value:
        "We're currently performing some updates to improve your experience. Please check back later. Thanks for your patience! 🚀",
    },
  TEXT_5_MIN: {
    key: "5MinKey",
    value: "5 min",
  },
  TEXT_10_MIN: {
    key: "10MinKey",
    value: "10 min",
  },
  TEXT_15_MIN: {
    key: "15MinKey",
    value: "15 min",
  },
  TEXT_30_MIN: {
    key: "30MinKey",
    value: "30 min",
  },
  TEXT_45_MIN: {
    key: "45MinKey",
    value: "45 min",
  },
  TEXT_1_HOUR: {
    key: "1HourKey",
    value: "1 hour",
  },
  TEXT_2_HOURS: {
    key: "2HoursKey",
    value: "2 hours",
  },
  SLEEP_TIMER: {
    key: "sleepTimerKey",
    value: "Sleep Timer",
  },
  AUDIO_WILL_FADE_OUT_AND_STOP_AFTER_THE_SELECTED_TIME: {
    key: "audioWillFadeOutAndStopAfterTheSelectedTimeKey",
    value: "Audio will fade out and stop after the selected time",
  },
  CUSTOM_TIME: {
    key: "customTimeKey",
    value: "Custom time",
  },
  MIN: {
    key: "minKey",
    value: "min",
  },
  SET: {
    key: "setKey",
    value: "Set",
  },
  CANCEL_TIMER: {
    key: "cancelTimerKey",
    value: "Cancel Timer",
  },
  CREATE_CONTENT_WITH_TEXT: {
    key: "createContentWithTextKey",
    value: "Create content with text",
  },
  PROVIDE_TEXT_TO_CONVERT: {
    key: "provideTextToConvertKey",
    value: "Provide text to convert",
  },
  ENTER_TEXT_HERE: {
    key: "enterTextHereKey",
    value: "Enter text here",
  },
  CREATE: {
    key: "createKey",
    value: "Create",
  },
  CONTACT_US: {
    key: "contactUsKey",
    value: "Contact Us",
  },
  WE_ARE_OPEN_TO_HELP_YOU_WITH_ANY_QUESTIONS_OR_SUPPORT: {
    key: "weAreOpenToHelpYouWithAnyQuestionsOrSupportKey",
    value: "We are open to help you with any questions or support",
  },
  FOR_QUESTIONS_SUGGESTIONS_OR_JUST_TO_SAY_HELLO_REACH_OUT_VIA_THE_SUPPORT_EMAIL_BELOW:
    {
      key: "forQuestionsSuggestionsOrJustToSayHelloReachOutViaTheSupportEmailBelowKey",
      value:
        "For questions, suggestions, or just to say hello reach out via the support email below.",
    },
  SUPPORT_EMAIL: {
    key: "supportEmailKey",
    value: "Support email:",
  },
  CREATE_CONTENT_WITH_WEB_URL: {
    key: "createContentWithWebUrlKey",
    value: "Create content with web url",
  },
  INVALID_URL: {
    key: "invalidUrlKey",
    value: "Invalid URL",
  },
  LINK_TO_DOCUMENT_OR_ANY_WEB_PAGE: {
    key: "linkToDocumentOrAnyWebPageKey",
    value: "Link to document or any web page",
  },
  MANAGE_SUBSCRIPTION: {
    key: "manageSubscriptionKey",
    value: "Manage Subscription",
  },
  CHANGE_EMAIL: {
    key: "changeEmailKey",
    value: "Change Email",
  },
  APPLY_PROMO_CODE: {
    key: "applyPromoCodeKey",
    value: "Apply Promo Code",
  },
  CHANGE_PASSWORD: {
    key: "changePasswordKey",
    value: "Change Password",
  },
  DELETE_ACCOUNT: {
    key: "deleteAccountKey",
    value: "Delete Account",
  },
  SCROLL_PROFILE_MENU_LEFT: {
    key: "scrollProfileMenuLeftKey",
    value: "Scroll profile menu left",
  },
  SCROLL_PROFILE_MENU_RIGHT: {
    key: "scrollProfileMenuRightKey",
    value: "Scroll profile menu right",
  },
  INITIALIZATION_ERROR: {
    key: "initializationErrorKey",
    value: "Initialization Error",
  },
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_YOUR_ACCOUNT: {
    key: "areYouSureYouWantToDeleteYourAccountKey",
    value: "Are you sure you want to delete your account?",
  },
  DELETE_YOUR_ACCOUNT: {
    key: "deleteYourAccountKey",
    value: "🗑️ Delete your account",
  },
  PLEASE_NOTE_ALL_OF_YOUR_DATA_WILL_BE_PERMANENTLY_REMOVED_FROM_OUR_SERVERS_FOREVER_THIS_ACTION_CANNOT_BE_UNDONE:
    {
      key: "pleaseNoteAllOfYourDataWillBePermanentlyRemovedFromOurServersForeverThisActionCannotBeUndoneKey",
      value:
        "Please note: All of your data will be permanently removed from our servers forever. This action cannot be undone.",
    },
  I_UNDERSTAND_THAT_THIS_ACTION_CANNOT_BE_UNDONE: {
    key: "iUnderstandThatThisActionCannotBeUndoneKey",
    value: "I understand that this action cannot be undone",
  },
  PICK_ALANGUAGE_FOR_YOUR_AUDIO_SVOICE: {
    key: "pickALanguageForYourAudioSVoiceKey",
    value: "🌍 Pick a language for your audio’s voice",
  },
  UNDER_MAINTENANCE: {
    key: "underMaintenanceKey",
    value: "Under Maintenance",
  },
  WE_ARE_CURRENTLY_WORKING_ON_ANEW_VERSION_OF_OUR_WEB_APP: {
    key: "weAreCurrentlyWorkingOnANewVersionOfOurWebAppKey",
    value: "We are currently working on a new version of our web app.",
  },
  WE_APOLOGIZE_FOR_THE_INCONVENIENCE_THE_SERVICE_WILL_BE_BACK_ONLINE_SOON: {
    key: "weApologizeForTheInconvenienceTheServiceWillBeBackOnlineSoonKey",
    value:
      "We apologize for the inconvenience. The service will be back online soon.",
  },
  IF_YOU_HAVE_ANY_QUESTIONS_PLEASE_CONTACT_US_AT: {
    key: "ifYouHaveAnyQuestionsPleaseContactUsAtKey",
    value: "If you have any questions, please contact us at",
  },
  OUR_IOS_AND_ANDROID_APPS_ARE_WORKING_AS_USUAL_SCAN_OR_DOWNLOAD: {
    key: "ourIosAndAndroidAppsAreWorkingAsUsualScanOrDownloadKey",
    value: "Our iOS and Android apps are working as usual. Scan or download:",
  },
  IMAGES: {
    key: "imagesKey",
    value: "Images",
  },
  RECENT_FILES: {
    key: "recentFilesKey",
    value: "Recent files",
  },
  NOW_FOR_THE_FUN_PART_LET_SPICK_AVOICE: {
    key: "nowForTheFunPartLetSPickAVoiceKey",
    value: "Now for the fun part — let's pick a voice!",
  },
  CHOOSE_WHICH_AI_VOICE_YOU_DLIKE_FOR_YOUR_GENERATED_AUDIO_YOU_CAN_ALWAYS_CHANGE_IT_LATER_IN_SETTINGS:
    {
      key: "chooseWhichAiVoiceYouDLikeForYourGeneratedAudioYouCanAlwaysChangeItLaterInSettingsKey",
      value:
        "Choose which AI voice you'd like for your generated audio. You can always change it later in Settings.",
    },
  REDIRECTING_TO_APP_STORE: {
    key: "redirectingToAppStoreKey",
    value: "Redirecting to app store...",
  },
  GET_THE_FRATECA_APP: {
    key: "getTheFratecaAppKey",
    value: "Get the Frateca App",
  },
  DOWNLOAD_THE_MOBILE_APP_TO_LISTEN_ON_THE_GO_YOUR_CONTENT_SYNCS_AUTOMATICALLY_ACROSS_ALL_DEVICES:
    {
      key: "downloadTheMobileAppToListenOnTheGoYourContentSyncsAutomaticallyAcrossAllDevicesKey",
      value:
        "Download the mobile app to listen on the go. Your content syncs automatically across all devices.",
    },
  CURRENT_PLAN: {
    key: "currentPlanKey",
    value: "Current plan:",
  },
  UPGRADE_TO_PREMIUM: {
    key: "upgradeToPremiumKey",
    value: "Upgrade to Premium",
  },
  ARCHIVED_FILES: {
    key: "archivedFilesKey",
    value: "Archived Files",
  },
  NO_ARCHIVED_CONTENT: {
    key: "noArchivedContentKey",
    value: "No archived content",
  },
  ITEMS_YOU_ARCHIVE_WILL_APPEAR_HERE_YOU_CAN_RESTORE_THEM_ANYTIME: {
    key: "itemsYouArchiveWillAppearHereYouCanRestoreThemAnytimeKey",
    value: "Items you archive will appear here. You can restore them anytime.",
  },
  UNLIMITED_AUDIO_CONVERSIONS: {
    key: "unlimitedAudioConversionsKey",
    value: "Unlimited Audio Conversions",
  },
  TRANSFORM_ANY_DOCUMENT_ARTICLE_OR_WEB_PAGE_INTO_ENGAGING_HIGH_QUALITY_AUDIO: {
    key: "transformAnyDocumentArticleOrWebPageIntoEngagingHighQualityAudioKey",
    value:
      "Transform any document, article, or web page into engaging, high-quality audio",
  },
  OFFLINE_LISTENING_ANYWHERE: {
    key: "offlineListeningAnywhereKey",
    value: "Offline Listening, Anywhere",
  },
  BOOST_PRODUCTIVITY_BY_READING_WHILE_YOU_DRIVE_WORK_OR_MULTI_TASK: {
    key: "boostProductivityByReadingWhileYouDriveWorkOrMultiTaskKey",
    value: "Boost productivity by reading while you drive, work or multi-task",
  },
  DOWNLOAD_SHARE_INSTANTLY: {
    key: "downloadShareInstantlyKey",
    value: "Download & Share Instantly",
  },
  GENERATE_AUDIO_FILES_AND_SHARE_THEM_WITH_FRIENDS_FAMILY_OR_COLLEAGUES: {
    key: "generateAudioFilesAndShareThemWithFriendsFamilyOrColleaguesKey",
    value:
      "Generate audio files and share them with friends, family, or colleagues",
  },
  PERSONALIZE_YOUR_EXPERIENCE: {
    key: "personalizeYourExperienceKey",
    value: "Personalize Your Experience",
  },
  TAILOR_YOUR_AUDIO_WITH_CUSTOMIZABLE_VOICES_AND_SPEEDS: {
    key: "tailorYourAudioWithCustomizableVoicesAndSpeedsKey",
    value: "Tailor your audio with customizable voices and speeds",
  },
  STAY_AHEAD_WITH_WEEKLY_UPDATES: {
    key: "stayAheadWithWeeklyUpdatesKey",
    value: "Stay Ahead with Weekly Updates",
  },
  BENEFIT_FROM_CONTINUOUS_INNOVATION_AND_ACCESS_TO_THE_LATEST_FEATURES: {
    key: "benefitFromContinuousInnovationAndAccessToTheLatestFeaturesKey",
    value:
      "Benefit from continuous innovation and access to the latest features",
  },
  GET_FRATECA_PRO: {
    key: "getFratecaProKey",
    value: "Get Frateca Pro",
  },
  LISTEN_TO_UNLIMITED_PDFS_PAPERS_WEBSITES_BOOKS: {
    key: "listenToUnlimitedPdfsPapersWebsitesBooksKey",
    value: "Listen to unlimited PDFs, papers, websites, books",
  },
  YEARLY: {
    key: "yearlyKey",
    value: "Yearly",
  },
  MONTHLY: {
    key: "monthlyKey",
    value: "Monthly",
  },
  TRY_PREMIUM_FOR_FREE_FOR3_DAYS: {
    key: "tryPremiumForFreeFor3DaysKey",
    value: "Try Premium for free for 3 Days",
  },
  RESTORE_PURCHASES: {
    key: "restorePurchasesKey",
    value: "Restore Purchases",
  },
  TERMS: {
    key: "termsKey",
    value: "Terms",
  },
  PRIVACY: {
    key: "privacyKey",
    value: "Privacy",
  },
  UPLOAD_FILES: {
    key: "uploadFilesKey",
    value: "UPLOAD FILES",
  },
  MULTITASK_LEARNING: {
    key: "multitaskLearningKey",
    value: "Multitask learning",
  },
  LEARN_WHILE_COMMUTING_EXERCISING_OR_WORKING: {
    key: "learnWhileCommutingExercisingOrWorkingKey",
    value: "Learn while commuting, exercising, or working",
  },
  NO_EYE_STRAIN: {
    key: "noEyeStrainKey",
    value: "No eye strain",
  },
  SAY_GOODBYE_TO_READING_FATIGUE: {
    key: "sayGoodbyeToReadingFatigueKey",
    value: "Say goodbye to reading fatigue",
  },
  NATURAL_AI_VOICES: {
    key: "naturalAiVoicesKey",
    value: "Natural AI voices",
  },
  PREMIUM_TEXT_TO_SPEECH_THAT_SOUNDS_HUMAN: {
    key: "premiumTextToSpeechThatSoundsHumanKey",
    value: "Premium text-to-speech that sounds human",
  },
  INSTANT_CONVERSION: {
    key: "instantConversionKey",
    value: "Instant conversion",
  },
  CONVERT_ANY_TEXT_TO_AUDIO_IN_SECONDS: {
    key: "convertAnyTextToAudioInSecondsKey",
    value: "Convert any text to audio in seconds",
  },
  READ_FASTER: {
    key: "readFasterKey",
    value: "Read faster.",
  },
  LEARN_MORE: {
    key: "learnMoreKey",
    value: "Learn more.",
  },
  CONVERT_TEXTBOOKS_PAPERS_PDFS_AND_WEB_PAGES_TO_NATURAL_SOUNDING_AUDIO_SAVE_TIME_BY_LISTENING_IN_YOUR_SPARE_MOMENTS:
    {
      key: "convertTextbooksPapersPdfsAndWebPagesToNaturalSoundingAudioSaveTimeByListeningInYourSpareMomentsKey",
      value:
        "Convert textbooks, papers, PDFs, and web pages to natural-sounding audio. Save time by listening in your spare moments.",
    },
  MINUTES_GENERATED: {
    key: "minutesGeneratedKey",
    value: "Minutes generated",
  },
  HOURS_SAVED: {
    key: "hoursSavedKey",
    value: "Hours saved",
  },
  RELOAD_PAGE: {
    key: "reloadPageKey",
    value: "Reload Page",
  },
  MOBILE_APP: {
    key: "mobileAppKey",
    value: "Mobile App",
  },
  LISTEN_ON_THE_GO: {
    key: "listenOnTheGoKey",
    value: "Listen on the Go",
  },
  SCAN_THE_QR_CODE_TO_DOWNLOAD_YOUR_LIBRARY_SYNCS_AUTOMATICALLY: {
    key: "scanTheQrCodeToDownloadYourLibrarySyncsAutomaticallyKey",
    value: "Scan the QR code to download. Your library syncs automatically.",
  },
  DOWNLOAD_ON_APP_STORE: {
    key: "downloadOnAppStoreKey",
    value: "Download on App Store",
  },
  GET_IT_ON_GOOGLE_PLAY: {
    key: "getItOnGooglePlayKey",
    value: "Get it on Google Play",
  },
  RENAME_CONTENT: {
    key: "renameContentKey",
    value: "Rename Content",
  },
  NEW_TITLE: {
    key: "newTitleKey",
    value: "New title",
  },
  ENTER_NEW_TITLE: {
    key: "enterNewTitleKey",
    value: "Enter new title",
  },
  ALREADY_PROCESSING_PLEASE_WAIT_FOR_THE_CURRENT_PROCESS_TO_COMPLETE: {
    key: "alreadyProcessingPleaseWaitForTheCurrentProcessToCompleteKey",
    value: "Already processing Please wait for the current process to complete",
  },
  WELCOME_TO_FRATECA: {
    key: "welcomeToFratecaKey",
    value: "Welcome to Frateca",
  },
  YOUR_INTELLIGENT_AUDIO_COMPANION: {
    key: "yourIntelligentAudioCompanionKey",
    value: "Your intelligent audio companion",
  },
  YOUR_PERSONALIZED_AUDIO_COMPANION: {
    key: "yourPersonalizedAudioCompanionKey",
    value: "Your Personalized Audio Companion",
  },
  CUSTOMIZE_BOOST_YOUR_PRODUCTIVITY_ADJUST_VOICE_STYLES_AND_SPEED_TO_CREATE_AN_EXPERIENCE_THAT_FITS_YOUR_LIFE_CONVERT_DOWNTIME_INTO_HANDS_FREE_ON_THE_GO_LEARNING_AND_MAKE_EVERY_MOMENT_PRODUCTIVE:
    {
      key: "customizeBoostYourProductivityAdjustVoiceStylesAndSpeedToCreateAnExperienceThatFitsYourLifeConvertDowntimeIntoHandsFreeOnTheGoLearningAndMakeEveryMomentProductiveKey",
      value:
        "Customize & Boost Your Productivity. Adjust voice styles and speed to create an experience that fits your life. Convert downtime into hands-free, on-the-go learning and make every moment productive.",
    },
  CUSTOMIZABLE: {
    key: "customizableKey",
    value: "Customizable",
  },
  PRODUCTIVE: {
    key: "productiveKey",
    value: "Productive",
  },
  EFFICIENT: {
    key: "efficientKey",
    value: "Efficient",
  },
  TRANSFORM_YOUR_READING_EXPERIENCE: {
    key: "transformYourReadingExperienceKey",
    value: "Transform Your Reading Experience",
  },
  TURN_ANY_TEXT_INTO_CLEAR_NATURAL_SOUNDING_AUDIO_LISTEN_TO_ARTICLES_EBOOKS_AND_DOCUMENTS_ANYWHERE_WHETHER_YOU_RE_COMMUTING_EXERCISING_OR_SIMPLY_RELAXING:
    {
      key: "turnAnyTextIntoClearNaturalSoundingAudioListenToArticlesEBooksAndDocumentsAnywhereWhetherYouReCommutingExercisingOrSimplyRelaxingKey",
      value:
        "Turn any text into clear, natural-sounding audio. Listen to articles, e-books, and documents anywhere—whether you're commuting, exercising, or simply relaxing.",
    },
  ARTICLES_EBOOKS: {
    key: "articlesEBooksKey",
    value: "Articles & E-books",
  },
  HIGH_QUALITY_AUDIO: {
    key: "highQualityAudioKey",
    value: "High Quality Audio",
  },
  LET_SGET_STARTED: {
    key: "letSGetStartedKey",
    value: "Let's Get Started!",
  },
  YOUR_NEW_WAY_TO_READ_AWAITS_DIVE_IN_AND_EXPERIENCE_THE_FREEDOM_OF_AUDIO_LEARNING_WITH_FRATECA:
    {
      key: "yourNewWayToReadAwaitsDiveInAndExperienceTheFreedomOfAudioLearningWithFratecaKey",
      value:
        "Your new way to read awaits. Dive in and experience the freedom of audio learning with Frateca.",
    },
  READY_TO_TRANSFORM_YOUR_READING: {
    key: "readyToTransformYourReadingKey",
    value: "Ready to transform your reading?",
  },
  JOIN_THOUSANDS_OF_USERS_ALREADY_ENJOYING_AUDIO_LEARNING: {
    key: "joinThousandsOfUsersAlreadyEnjoyingAudioLearningKey",
    value: "Join thousands of users already enjoying audio learning",
  },
  SOMETING_WENT_WRONG_IF_SUBSCRIBTION_PLAN_WAS_NOT_ASSIGNED_PLEASE_CONTACT_SUPPORT:
    {
      key: "sometingWentWrongIfSubscribtionPlanWasNotAssignedPleaseContactSupportKey",
      value:
        "Someting went wrong, if subscribtion plan was not assigned please contact support",
    },
  FINALIZING_ACCESS: {
    key: "finalizingAccessKey",
    value: "Finalizing access…",
  },
  CONGRATULATIONS: {
    key: "congratulationsKey",
    value: "Congratulations!",
  },
  YOUR_PURCHASE_WAS_SUCCESSFUL_WE_ARE_NOW_SETTING_UP_YOUR_PREMIUM_ACCESS_THIS_MAY_TAKE_UP_TO2_MINUTES:
    {
      key: "yourPurchaseWasSuccessfulWeAreNowSettingUpYourPremiumAccessThisMayTakeUpTo2MinutesKey",
      value:
        "Your purchase was successful! We are now setting up your premium access. This may take up to 2 minutes.",
    },
  PLEASE_WAIT_WHILE_WE_FINALIZE_YOUR_SUBSCRIPTION_THE_APP_WILL_REFRESH_AUTOMATICALLY_ONCE_EVERYTHING_IS_READY:
    {
      key: "pleaseWaitWhileWeFinalizeYourSubscriptionTheAppWillRefreshAutomaticallyOnceEverythingIsReadyKey",
      value:
        "Please wait while we finalize your subscription. The app will refresh automatically once everything is ready. 🚀",
    },
  IF_THIS_TAKES_TOO_LONG_TRY_RESTORING_YOUR_PURCHASE_OR_CONTACT_SUPPORT: {
    key: "ifThisTakesTooLongTryRestoringYourPurchaseOrContactSupportKey",
    value:
      "If this takes too long, try restoring your purchase or contact support.",
  },
  SYSTEM: {
    key: "systemKey",
    value: "System",
  },
  LIGHT: {
    key: "lightKey",
    value: "Light",
  },
  DARK: {
    key: "darkKey",
    value: "Dark",
  },
  UNSUPPORTED_FILE_TYPE: {
    key: "unsupportedFileTypeKey",
    value: "Unsupported file type",
  },
  OK: {
    key: "okKey",
    value: "Ok",
  },
  MIN_LEFT: {
    key: "minLeftKey",
    value: "min left",
  },
  WE_COULD_NOT_DETECT_ANY_TEXT_IN_YOUR_IMAGE2: {
    key: "weCouldNotDetectAnyTextInYourImage2Key",
    value: "We could not detect any text in your image",
  },
  CHANGE_YOUR_PASSWORD: {
    key: "changeYourPasswordKey",
    value: "🔒 Change your password",
  },
  OLD_PASSWORD_IS_REQUIRED: {
    key: "oldPasswordIsRequiredKey",
    value: "Old password is required",
  },
  PASSWORD_MUST_BE_AT_LEAST6_CHARACTERS_LONG: {
    key: "passwordMustBeAtLeast6CharactersLongKey",
    value: "Password must be at least 6 characters long",
  },
  OLD_PASSWORD: {
    key: "oldPasswordKey",
    value: "Old password",
  },
  NEW_PASSWORD_IS_REQUIRED: {
    key: "newPasswordIsRequiredKey",
    value: "New password is required",
  },
  NEW_PASSWORD: {
    key: "newPasswordKey",
    value: "New password",
  },
  CONFIRM_NEW_PASSWORD_IS_REQURIED: {
    key: "confirmNewPasswordIsRequriedKey",
    value: "Confirm new password is requried",
  },
  CONFIRM_NEW_PASSWORD: {
    key: "confirmNewPasswordKey",
    value: "Confirm new password",
  },
  YOU_CAN_SWITCH_LANGUAGE_FOR_YOUR_AUDIO_SVOICE: {
    key: "youCanSwitchLanguageForYourAudioSVoiceKey",
    value: "🌍 You can switch language for your audio’s voice",
  },
  NOW_LET_SPICK_ANEW_VOICE: {
    key: "nowLetSPickANewVoiceKey",
    value: "Now let's pick a new voice!",
  },
  CHOOSE_THIS_VOICE: {
    key: "chooseThisVoiceKey",
    value: "Choose this voice",
  },
  CURRENT_VOICE: {
    key: "currentVoiceKey",
    value: "🔥 Current voice:",
  },
  PROMO_CODE: {
    key: "promoCodeKey",
    value: "Promo code",
  },
  ARE_YOU_SURE_YOU_WANT_TO_CHANGE_YOUR_EMAIL: {
    key: "areYouSureYouWantToChangeYourEmailKey",
    value: "Are you sure you want to change your email?",
  },
  EMAIL: {
    key: "emailKey",
    value: "✉️ Email:",
  },
  IN_ORDER_TO_CHANGE_YOUR_EMAIL_WE_NEED_TO_SEND_ACONFIRMATION_CODE_TO_YOUR_CURRENT_EMAIL:
    {
      key: "inOrderToChangeYourEmailWeNeedToSendAConfirmationCodeToYourCurrentEmailKey",
      value:
        "In order to change your email, we need to send a confirmation code to your current email.",
    },
  FURTHER_YOU_WILL_PROVIDE_ANEW_EMAIL_AND_CONFIRM_IT_WITH_THE_CODE: {
    key: "furtherYouWillProvideANewEmailAndConfirmItWithTheCodeKey",
    value: "Further you will provide a new email and confirm it with the code.",
  },
  START_CHANGING_EMAIL: {
    key: "startChangingEmailKey",
    value: "➡️ Start changing email",
  },
  CODE_IS_REQUIRED: {
    key: "codeIsRequiredKey",
    value: "Code is required",
  },
  CODE: {
    key: "codeKey",
    value: "Code",
  },
  EMAIL_IS_REQUIRED: {
    key: "emailIsRequiredKey",
    value: "Email is required",
  },
  CONTINUE_AS_GUEST: {
    key: "continueAsGuestKey",
    value: "Continue as guest",
  },
  GUEST_MODE_DESCRIPTION: {
    key: "guestModeDescriptionKey",
    value: "Try Frateca without creating an account",
  },
  GUEST_LIMIT_REACHED: {
    key: "guestLimitReachedKey",
    value: "Guest limit reached",
  },
  CREATE_ACCOUNT_TO_CONTINUE: {
    key: "createAccountToContinueKey",
    value: "Create an account to keep your note and continue creating content.",
  },
  CREATE_ACCOUNT: {
    key: "createAccountFromGuestKey",
    value: "Create account",
  },
  CONNECT_EMAIL: {
    key: "connectEmailKey",
    value: "Connect email",
  },
  CONNECT_EMAIL_DESCRIPTION: {
    key: "connectEmailDescriptionKey",
    value: "Connect an email and password without losing your library or settings.",
  },
  GUEST_ACCOUNT_WARNING: {
    key: "guestAccountWarningKey",
    value: "You are using guest mode. Connect an email so you do not lose this account.",
  },
  CONFIRM_YOUR_EMAIL: { key: "confirmYourEmailKey", value: "Confirm your email" },
  GUEST_PENDING_EMAIL_DESCRIPTION: { key: "guestPendingEmailDescriptionKey", value: "We sent a 6-digit code to your email. Your guest account remains unchanged until you confirm it." },
  CONFIRM_EMAIL: { key: "confirmEmailKey", value: "Confirm email" },
  EDIT_EMAIL: { key: "editEmailKey", value: "Edit email" },
  RESEND_CODE: { key: "resendCodeKey", value: "Resend code" },
  CANCEL: { key: "cancelKey", value: "Cancel" },
  BACK_TO_CONFIRMATION: { key: "backToConfirmationKey", value: "Back to confirmation" },
  CONFIRMATION_CODE_SENT: { key: "confirmationCodeSentKey", value: "Confirmation code sent" },
  EXTENSION_ACCOUNT_CONNECTED: {
    key: "extensionAccountConnectedKey",
    value: "You're all set! Your extension is connected to your account.",
  },
  UNIFIED_LIBRARY_AVAILABLE: {
    key: "unifiedLibraryAvailableKey",
    value: "Your library is available across the extension, web app, and mobile app.",
  },
  EXTENSION_GUEST_CONNECTED: {
    key: "extensionGuestConnectedKey",
    value: "Guest mode is ready in the extension and web app.",
  },
  GUEST_LIBRARY_SYNC_DESCRIPTION: {
    key: "guestLibrarySyncDescriptionKey",
    value: "Your library is shared here too. Connect an email later to protect it without losing your content.",
  },
  INTERFACE_LANGUAGE: {
    key: "interfaceLanguageKey",
    value: "Interface language",
  },
  INTERFACE_LANGUAGE_DESCRIPTION: {
    key: "interfaceLanguageDescriptionKey",
    value: "Choose the language used throughout the Frateca interface.",
  },
  INTERFACE_LANGUAGE_HELP: {
    key: "interfaceLanguageHelpKey",
    value: "Menus, buttons, and other interface text will use this language.",
  },
  PRO_DISCOUNT: { key: "proDiscountKey", value: "56% OFF" },
  YEARLY_MONTHLY_PRICE: { key: "yearlyMonthlyPriceKey", value: "3.95 US$/mo" },
  YEARLY_BILLING_NOTE: { key: "yearlyBillingNoteKey", value: "Billed at USD 47.50/yr." },
  MONTHLY_PRICE: { key: "monthlyPriceKey", value: "USD 8.99/mo" },
  MONTHLY_BILLING_NOTE: { key: "monthlyBillingNoteKey", value: "Billed at USD 8.99/mo." },
} as const
